import { CornerDownLeft, MoveRight } from 'lucide-react';
import React from 'react';
import Button from '../Button';
import Card from '../Card';
import Label from '../Label';
import MultiSelect, { Option } from '../MultiSelect';
import Textarea from '../Textarea';
import { Tooltip, TooltipTrigger } from '../Tooltip';
import CustomSelectItem from './custom-select';


type GuestTeamMemberProps = {
    handleGuestMultiSelectOnChange: (options: Option[]) => void,
    multiSelectguestValue: Option[] | undefined,
    handleChangeGuestNote: React.ChangeEventHandler<HTMLTextAreaElement> | undefined,
    guestNote: string | number | readonly string[] | undefined,
    handleInviteGuest: () => void,
    inviteTeamLink: string,
    collabLink: string,
    isInvitingMember: boolean,
}

const CollaboratorClient = ({ handleGuestMultiSelectOnChange, multiSelectguestValue, handleChangeGuestNote, guestNote, handleInviteGuest, isInvitingMember }: GuestTeamMemberProps) => {


    return (
        <Card className="mt-4 border-none shadow-none">
            <Card.Content className="flex flex-col w-full gap-4 p-0">
                <div className="relative flex w-full items-start gap-2 flex-col">
                    <Label>Who would you like to invite?</Label>
                    <div className="relative flex w-full items-center gap-2">
                        <MultiSelect
                            creatable
                            options={multiSelectguestValue}
                            placeholder="Add an Email Address, then click Enter to add another..."
                            onChange={handleGuestMultiSelectOnChange}
                            value={multiSelectguestValue}
                            hideClearAllButton
                            customItemComponent={CustomSelectItem}
                            rightSection={
                                <Tooltip
                                    content="Pressing enter on your keyboard will add the email address"
                                    delayDuration={100}
                                    side='bottom'
                                    align='end'
                                >
                                    <TooltipTrigger asChild>
                                        <span className="right-1 flex h-[28px] w-8 items-center justify-center rounded-md bg-[#EFF2F6] dark:bg-card text-textcolor">
                                            <CornerDownLeft
                                                size={14} />
                                        </span>
                                    </TooltipTrigger>
                                </Tooltip>
                            }

                        />

                    </div>
                </div>
                <div>
                    <Label>Would you like to add a note?</Label>
                    <Textarea className='placeholder:text-muted-foreground' placeholder="Tell them why you’re inviting them to this project..." value={guestNote} onChange={handleChangeGuestNote} />
                </div>
                <Card.Footer className='flex justify-end px-0 pb-2'>
                    <Button
                        variant="primary"
                        size="sm"
                        onClick={handleInviteGuest}
                        loading={isInvitingMember}
                    >
                        Submit
                        <MoveRight size={18} />
                    </Button>
                </Card.Footer>
            </Card.Content>
        </Card>
    );
};

export default CollaboratorClient;
